export default __webpack_public_path__ + "static/media/green-loader.5f067b6c.svg";